import React from 'react';
import '../styles/Dialog.css'; // 다이얼로그 스타일을 위한 CSS 파일

// Dialog 컴포넌트 - 여러 유형의 다이얼로그를 처리할 수 있는 범용 컴포넌트
const DIALOG_TYPES = {
  EDIT_SUCCESS: 'edit-success',
  RESET_CONFIRM: 'reset-confirm',
  RESET_SUCCESS: 'reset-success',
  COMPANY_EDIT_SUCCESS: 'company-edit-success',
  COMPANY_EDIT_ERROR: 'company-edit-error',
  COMPANY_DELETE_CONFIRM: 'company-delete-confirm',
  COMPANY_DELETE_SUCCESS: 'company-delete-success',
  COMPANY_DELETE_ERROR: 'company-delete-error',
  REFUND_APPROVE_CONFIRM: 'refund_approve_confirm',
  REFUND_APPROVE_COMPLETE: 'refund_approve_complete',
  REFUND_REJECT_CONFIRM: 'refund_reject_confirm',
  REFUND_REJECT_COMPLETE: 'refund_reject_complete',
  CONTRACT_EDIT_SUCCESS: 'contract-edit-success',
  TIME_FORMAT_ERROR: 'time-format-error',
  WAGE_FORMAT_ERROR: 'wage-format-error',
  EMPLOYEE_EDIT_SUCCESS: 'employee-edit-success',
  ERROR: 'error',
  SUCCESS: 'success',
};

const Dialog = (props) => {
  const { isOpen, onClose, type, onConfirm, message: customMessage, onCancel } = props;
  
  if (!isOpen) return null;

  let title, message, confirmText, cancelText;

  // 다이얼로그 유형에 따라 내용 설정
  switch (type) {
    case DIALOG_TYPES.EDIT_SUCCESS:
      title = '공지사항 수정';
      message = '공지사항이 수정되었습니다.';
      confirmText = '확인';
      cancelText = null;
      break;
    
    case DIALOG_TYPES.RESET_CONFIRM:
      title = '공지사항 초기화';
      message = '공지사항을 초기화 하시겠습니까?';
      confirmText = '예';
      cancelText = '아니오';
      break;
    
    case DIALOG_TYPES.RESET_SUCCESS:
      title = '공지사항 초기화';
      message = '공지사항이 초기화되었습니다.';
      confirmText = '확인';
      cancelText = null;
      break;
    
    // 새로 추가된 업체 정보 수정 완료 다이얼로그
    case DIALOG_TYPES.COMPANY_EDIT_SUCCESS:
      title = '업체 정보 수정';
      message = '업체 정보가 수정되었습니다.';
      confirmText = '확인';
      cancelText = null;
      break;
    
    // 업체 삭제 확인 다이얼로그 (NEW)
    case DIALOG_TYPES.COMPANY_DELETE_CONFIRM:
      title = '업체 삭제';
      message = '정말로 이 업체를 삭제하시겠습니까?';
      confirmText = '예';
      cancelText = '아니오';
      break;
    
    // 업체 삭제 완료 다이얼로그 (NEW)
    case DIALOG_TYPES.COMPANY_DELETE_SUCCESS:
      title = '업체 삭제';
      message = '업체가 삭제되었습니다.';
      confirmText = '확인';
      cancelText = null;
      break;
    
    // 환불 요청 승인 관련 다이얼로그 설정
    case DIALOG_TYPES.REFUND_APPROVE_CONFIRM:
      title = '환불 요청 승인';
      message = '환불 요청을 승인하시겠습니까?';
      confirmText = '예';
      cancelText = '아니오';
      break;
    
    case DIALOG_TYPES.REFUND_APPROVE_COMPLETE:
      title = '환불 요청 승인 완료';
      message = '환불 요청이 승인되었습니다.';
      confirmText = '확인';
      cancelText = null;
      break;
    
    // 환불 요청 거절 관련 다이얼로그 설정
    case DIALOG_TYPES.REFUND_REJECT_CONFIRM:
      title = '환불 요청 거절';
      message = '환불 요청을 거절하시겠습니까?';
      confirmText = '예';
      cancelText = '아니오';
      break;
    
    case DIALOG_TYPES.REFUND_REJECT_COMPLETE:
      title = '환불 요청 거절 완료';
      message = '환불 요청이 거절되었습니다.';
      confirmText = '확인';
      cancelText = null;
      break;
    
    // 계약 정보 수정 성공
    case DIALOG_TYPES.CONTRACT_EDIT_SUCCESS:
      title = '계약 정보 수정';
      message = '계약 정보가 수정되었습니다.';
      confirmText = '확인';
      cancelText = null;
      break;
    
    // 시간 형식 오류
    case DIALOG_TYPES.TIME_FORMAT_ERROR:
      title = '시간 형식 오류';
      message = '시간은 00:00 ~ 23:59 형식으로 입력해주세요.';
      confirmText = '확인';
      cancelText = null;
      break;
    
    // 임금 형식 오류
    case DIALOG_TYPES.WAGE_FORMAT_ERROR:
      title = '임금 형식 오류';
      message = '임금은 숫자만 입력 가능합니다.';
      confirmText = '확인';
      cancelText = null;
      break;
    
    // 직원 정보 수정 성공
    case DIALOG_TYPES.EMPLOYEE_EDIT_SUCCESS:
      title = '직원 정보 수정';
      message = '직원 정보가 수정되었습니다.';
      confirmText = '확인';
      cancelText = null;
      break;
    
    // 오류 다이얼로그
    case DIALOG_TYPES.ERROR:
      title = '오류';
      message = customMessage || '오류가 발생했습니다.';
      confirmText = '확인';
      cancelText = null;
      break;
    
    // 성공 다이얼로그 (NEW)
    case DIALOG_TYPES.SUCCESS:
    case 'success': // 문자열로도 처리
      title = '성공';
      message = customMessage || '작업이 성공적으로 완료되었습니다.';
      confirmText = '확인';
      cancelText = null;
      break;
    
    // 업체 수정 오류 다이얼로그
    case DIALOG_TYPES.COMPANY_EDIT_ERROR:
      title = '업체 정보 수정 오류';
      message = customMessage || '업체 정보 수정 중 오류가 발생했습니다.';
      confirmText = '확인';
      cancelText = null;
      break;
    
    // 업체 삭제 오류 다이얼로그 (NEW)
    case DIALOG_TYPES.COMPANY_DELETE_ERROR:
      title = '업체 삭제 오류';
      message = customMessage || '업체 삭제 중 오류가 발생했습니다.';
      confirmText = '확인';
      cancelText = null;
      break;
    
    default:
      title = '알림';
      message = customMessage || '작업이 완료되었습니다.';
      confirmText = '확인';
      cancelText = null;
  }

  // 취소 버튼이 있는 다이얼로그 타입인지 확인
  const hasConfirmCancel = [
    DIALOG_TYPES.RESET_CONFIRM,
    DIALOG_TYPES.REFUND_APPROVE_CONFIRM,
    DIALOG_TYPES.REFUND_REJECT_CONFIRM,
    DIALOG_TYPES.COMPANY_DELETE_CONFIRM
  ].includes(type);

  return (
    <div className="dialog-overlay">
      <div className="dialog-container">
        <div className="dialog-header">
          <h2 className="dialog-title">{title}</h2>
        </div>
        <div className="dialog-content">
          <p className="dialog-message">{message}</p>
        </div>
        <div className="dialog-footer">
          {cancelText && (
            <button 
              className={hasConfirmCancel ? "dialog-refund-no-button" : "dialog-cancel-button"}
              onClick={onCancel || onClose}
            >
              {cancelText}
            </button>
          )}
          <button 
            className={hasConfirmCancel ? "dialog-refund-yes-button" : "dialog-refund-confirm-button"}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

// Export dialog types for external use
Dialog.TYPES = DIALOG_TYPES;

export default Dialog; 